import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Details } from 'components/details'
import { Title as TitleBase } from 'components/misc'
import Utka from './assets/utka.webp'
import { SliderMythology } from './slider-mythology'
import { Title } from './styled'

export const Mythology = forwardRef<HTMLDivElement>((_, ref) => (
  <section>
    <div ref={ref}>
      <Title data-menu-title="сотворение мира">
        <TextContainer>Как был сотворен мир</TextContainer>
      </Title>

      <TextContainer className="komi-mythology-margin-bottom">
        <p>
          В мифологии коми утка играет особую роль и считается прародительницей
          всего живого на земле. Утка-Чöж – божественное существо, она
          символизирует плодородие, семейное благополучие и источник жизни.
        </p>
        <p>
          По легенде, Утка-Чöж была первым существом на земле. Она плавала по
          бесконечному первозданному морю-океану и несла в себе 6 яиц
          жизнерождения. Четыре яйца она уронила на дно моря-океана, а из двух
          оставшихся появились два брата-утенка, Ён и Омöль. Они были
          противоположностями: добром и злом, светом и тьмой, правдой и
          неправдой.
        </p>
      </TextContainer>

      <Details posterImage={Utka}>
        <TextContainer>
          <p>
            Когда братья были маленькими, Утка-Мать носила их на спине. Когда
            они выросли, она попросила их достать яйца со дна моря-океана и
            разбить их о ее тело. Сама же Утка-Мать взлетела в небо. А затем
            бросилась вниз и разбилась о воду. Из ее тела появилась земля, леса,
            зелень и цветы.
          </p>

          <p>
            Братья стали нырять на дно моря-океана. Из первого поднятого со дна
            и разбитого о тело матери яйца появилось солнце. Из второго Ён
            создал себе помощников, ангелов. Из третьего яйца появляются луна,
            озера, болота и зыбуны. Из четвертого яйца появились помощники
            Омöля. Так и создавали два брата все на свете, в том числе и людей.
          </p>

          <p>
            "Ён создал белку, чтобы человек мог на нее охотиться; Омöль сотворил
            куницу, чтобы она ела белку; в ответ на это Ён создал собаку, чтобы
            она помогала человеку охотиться на куницу и стерегла дом. Ён
            сотворил петуха и курицу, тетерева, куропатку и рябчика. Омöль из
            вредности создал ястреба, филина, ворону и хищных зверей: лисицу,
            рысь, росомаху и др. Ён сотворил лягушку, а Омöль – лося, оленя,
            зайца, кошку, крыс, мышей, ящериц, всех рыб и вредных насекомых.
            Кошке Ён дал теплую шерсть, разрешил жить в доме у людей, а за это
            обязал ее ловить мышей и крыс. Омöль, в свою очередь, дал шерсть
            собаке, после чего ей было запрещено находиться в доме".
          </p>
        </TextContainer>
      </Details>
    </div>

    <div ref={ref}>
      <TitleBase data-menu-title="мифология коми">
        <TextContainer>Мифология коми</TextContainer>
      </TitleBase>

      <TextContainer>
        <p>
          У народов коми существовала особая иерархия богов, которая в процессе
          христианизации была утеряна. Единственным сохранившимся до наших дней
          источником информации является книга миссионера Стефана Пермского. Он
          проповедовал христианство в Коми и изучал историю этого народа. В
          своей книге "Житие Стефана Пермского" миссионер рассказал о пантеоне
          богов охоты, леса, животных, воды, воздуха, которые говорят с коми на
          особом языке и объединены в двухуровневую систему: мир людей и
          потусторонний мир. Дом у коми олицетворяет мироздание.
        </p>
        <p>
          Изначально его построили два главных бога – Ён и Омöль. Они всегда
          боролись за верховенство в мире людей. Ён сотворил животных для людей,
          например курицу, а его брат Омöль сделал ястреба и всех хищников,
          которые поедали этих животных. Ён сотворил солнце, а Омöль – луну. Эта
          борьба продолжалась долго. Но иногда братья творили вместе, так,
          например, была создана скрипка Сигудöк, появилось кузнечное ремесло.
          После окончания борьбы с братом за верховенство Омöль ушел под землю и
          стал хозяином космического низа, или подземного мира.
        </p>
      </TextContainer>

      <SliderMythology />
    </div>
  </section>
))
